export default "__VITE_ASSET__723c298a__"